module.exports = __webpack_public_path__ + "pc/img/icon2.fa296021.png";